<template>
  <!-- delete modal -->
  <b-modal id="deleteObjectModal" centered modal-class="modal-astrology">
    <div class="d-block mb-4">
      <p class="confirmMessageModalP message-modal-av my-4">
        Are you sure to delete this object? 
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="astrology-danger"
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="clickConfirmDelete"
          >
            Yes
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="astrology-secondary-outline"
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="closeModalDelete"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
  <!-- end delete modal-->
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteObject",
  props: ["client_name","object_id"],
  data() {
    return {
      is_loading: false,
    };
  },
  mounted() {
    // console.log(this.$parent)
  },
  methods: {
    clickConfirmDelete() {
      console.log(
        "confirm delete object",
        this.object_id,
        this.client_name
      );
      this.$bvModal.hide("deleteObjectModal");
    },

    closeModalDelete() {
      this.$bvModal.hide("deleteObjectModal");
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/content_management/DeleteObject.vue